import { render, staticRenderFns } from "./GoodsAddModal.vue?vue&type=template&id=85f6707c&scoped=true&"
import script from "./GoodsAddModal.vue?vue&type=script&lang=js&"
export * from "./GoodsAddModal.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAddModal.vue?vue&type=style&index=0&id=85f6707c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f6707c",
  null
  
)

export default component.exports